<template>
  <v-row justify="center">
    <v-dialog v-model="bMostrar" persistent max-width="655px">
      <v-progress-linear v-if="cargando" indeterminate color="titlesdark darken-2" />
      <v-card>
        <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
          <v-spacer />
          <span class="mdlHeadForms">{{oEquivalencias.ttlEditarTicket}}</span>
          <v-spacer/>
          <v-btn
            color="btncolor-dark"
            @click="bMostrar = false"
            icon
            small
            dark
            outlined
          >
            <v-icon size="14px">fa fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <FormSelect
                    v-model="oForm.idPrioridad_requerimiento"
                    :titulo="oEquivalencias.cmpPrioridad"
                    :inner="'PQR_Prioridad_requerimiento,'"
                    :campo="'Prioridad'"
                    :obligatorio="true"
                    :editable="'1'"
                />
              </v-col>
              <v-col cols="12">
                <FormSelect
                    v-model="oForm.IDTipo"
                    :titulo="oEquivalencias.cmpTipoRequerimiento"
                    :inner="'PQR_Tipos_requerimiento,'"
                    :campo="'Detalle'"
                    :obligatorio="true"
                    :editable="'1'"
                />
              </v-col>
              <v-col cols="12">
                <FormSelectFiltro
                    v-model="oForm.idPQR_SubTipo"
                    :titulo="oEquivalencias.cmpSubTipoRequerimiento"
                    :inner="'PQR_SubTipo,'"
                    :campo="'SubTipo'"
                    :obligatorio="true"
                    :campoFiltro="'idPQR_Tipos_requerimiento'"
                    :valorFiltro="oForm.IDTipo"
                    :editable="'1'"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn dark outlined color="primary" @click="onInit()" :disabled="cargando">
                {{ oEquivalencias.btnLimpiar }}
            </v-btn>
            <v-btn dark outlined color="primary" @click="onGuardar()">
                {{ cargando ? oEquivalencias.lblCargando : oEquivalencias.btnGuardar }}
            </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
  <script>
import axiosServices from "@/services/axiosServices.js";
import FormSelect from "@/components/Form/Componentes/FormSelect.vue";
import FormSelectFiltro from "@/components/Form/Componentes/FormSelectFiltro.vue";

export default {
  components: {
    FormSelect,
    FormSelectFiltro
  },
  name: "EditarTicketModal",
  props: {
    sTable: {
      type: String,
    },
    sTitle: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      cargando: false, // empleada para indicar que el form esta cargando
      Mensaje: "Cargando..",
      bMostrar: false,
      bDisabled: false,
      oForm: {
        idPrioridad_requerimiento: 0,
        IDTipo: "0",
        idPQR_SubTipo: 0
      }, 
      idRequerimiento: 0,
      // almacenamos el objeto de equivalencias del store 
      oEquivalencias: this.$store.state.jsIdioma.oEquivalencias
    };
  },
  mounted() {
    // code
  },
  methods: {
    limpiarCampos() {
      this.showDobleSelect = false;
      this.department = "";
    },
    onInit() {
        this.oForm = {
            idPrioridad_requerimiento: 0,
            IDTipo: '0',
            idPQR_SubTipo: 0
        };
        this.cargando = false;
    },
    async onGetForm() {
    // Al cargar por primer vez el formulario se consulta los datos para precargarlos
      const { aData } = await axiosServices.getConfiguration(`/pqr_verTicket/${this.idRequerimiento}`, true, '');
      this.oForm = {
        idPrioridad_requerimiento : aData.Prioridad,
        IDTipo: aData.IDTipo_requerimiento,
        idPQR_SubTipo: aData.idPQR_SubTipo
      }
    },
    async onGuardar() {
        this.cargando = true;
        let bFormulario = true;
        for (const key in this.oForm) {
            if(this.oForm[key] === 0 || this.oForm[key] === '0' || this.oForm[key] === undefined) {
                bFormulario = false;                
            }
        }
        //console.log(this.oForm);
        if(bFormulario) {
            const { nStatusCode, sMessage, sStatus} = await axiosServices.putConfiguration(`/pqr_editarTicket/${this.idRequerimiento}`, this.oForm, true);
            if(nStatusCode == 200) {
                this.idRequerimiento = 0;
                this.onInit();
                this.$emit('onSuccessEdit', {sMessage: sMessage, sStatus: sStatus });
            }
        } else {
            this.$swal({
                timer: 1500,
                icon: `error`,
                title: `Asegurese de completar todos los campos`,
                showConfirmButton: false,
            });
            this.cargando = false;
        } 
    }
  },
};
</script>